import { LitElement, html, css } from 'lit';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInRemoteContent extends LitElement {
    static properties = {
        _loading: { state: true, type: Boolean },
        content: { type: String, reflect: true },
        get: { type: String },
        nonce: { type: String }
    };
    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.content) {
            this._loading = true;
            this.loadContent();
        }
        else {
            this._loading = false;
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('content')) {
            this.renderRoot.querySelector('.content').innerHTML = this.content;
        }
    }
    render() {
        if (this._loading) {
            return html `<allin-loader loading></allin-loader>`;
        }
        else {
            return html `<div class="content"></div>`;
        }
    }
    async loadContent() {
        if (this.get) {
            try {
                let response = await fetch(this.get, {
                    headers: {
                        'AllIn-Nonce': this.nonce,
                    }
                });
                if (response.status === 403) {
                    handle403s();
                    return;
                }
                let data = await response.json();
                this._loading = false;
                this.content = data;
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    static styles = [
        css `
        
        `
    ];
}
